import { setCookie } from "../util/cookieTools";
import isMobileBuild from "../util/isMobileBuild";
import { Preferences } from "@capacitor/preferences";

const PREFERRED_THEME = "preferredTheme";

export default {
  computed: {
    isLoggedIn() {
      return !!this.$store.state.userId;
    },
  },
  methods: {
    logout: function () {
      setCookie("authorization", "", -1);
      delete this.$axios.defaults.headers.common["Authorization"];
      this.$store.commit("logout");

      // Send user back to home
      this.$router.push({ name: "home" }).catch(() => {});

      if (isMobileBuild()) {
        // Update mobile state
        Preferences.remove({
          key: "authorization",
        }).then(() => {}); // TODO: Clean up to async await
      }
    },
    getThemeFromStorage: async function () {
      let theme = null;
      if (!isMobileBuild()) {
        theme = localStorage.getItem(PREFERRED_THEME);
      } else {
        const themeKeyValue = await Preferences.get({
          key: PREFERRED_THEME,
        });
        if (themeKeyValue) {
          theme = themeKeyValue.value;
        }
      }
      return theme;
    },
    saveThemeToStorage: async function (theme) {
      localStorage.setItem(PREFERRED_THEME, theme);
      if (isMobileBuild()) {
        await Preferences.set({
          key: PREFERRED_THEME,
          value: theme,
        });
      }
    },
  },
};
